import { EventEmitter, Inject, Injectable, OnInit } from '@angular/core';
import { Headers, Http } from "@angular/http";
import { MsalService } from '../services/msal.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

interface ProfileData {
    date: string;
    value: string;
}

interface ApxTtem { biedUur: number; prijsEuroPerMWh: number; totDatumTijd: number; vanDatumTijd: number }

interface ApxData {
    data: {
        apx: ApxTtem[]
    }
}

interface Participant {
    id: string;
    islandId: string;
    islandName: string;
    hasMeteringPoints: boolean;
}

@Injectable()
export class EnergyDataService implements OnInit {
    // Participant info
    participantInfo: Participant | null = null;

    // Demo data
    energyProfileData: ProfileData[] | null = null;
    solarProfileData: ProfileData[] | null = null;
    gasProfileData: ProfileData[] | null = null;

    islandSolarProfile: ProfileData[] | null = null;
    islandEnergyProfile: ProfileData[] | null = null;

    // Actual data
    energyActualData: ProfileData[] | null = null;
    solarActualData: ProfileData[] | null = null;
    gasActualData: ProfileData[] | null = null;

    islandSolarActual: ProfileData[] | null = null;
    islandEnergyActual: ProfileData[] | null = null;

    // Pricing
    apxProfile: ApxData | null = null;
    apxActualData: ProfileData[] | null = null;

    dataLoadedEvent = new EventEmitter<string>();

    constructor(
        private http: Http,
        private msalService: MsalService,
        @Inject('BASE_URL') private baseUrl: string) {
        console.log('Constructing EnergyDataService')
    }

    ngOnInit(): void {
        this.load();
    }

    load() {
        console.log('Loading energy data');
        this.msalService.getToken().then((token: string) => {
            let headers = new Headers();
            headers.append('Authorization', 'Bearer ' + token);
            headers.append('Cache-Control', 'max-age=5');
            this.http.post(this.baseUrl + 'api/participant/verify', { }, { headers: headers })
                .subscribe(
                    // Participant verified, so retrieve personal data
                    data => {
                        this.dataLoadedEvent.emit("participant-verified");
                        this.http.get(this.baseUrl + 'api/participant/current', { headers: headers })
                            .map(res => res.json() as Participant)
                            .subscribe(
                                data => {
                                    this.participantInfo = data;
                                    this.dataLoadedEvent.emit("participant");
                                },
                                error => console.error(error));


                        this.http.get(this.baseUrl + 'api/data/energyconsumption', { headers: headers })
                            .map(res => res.json() as ProfileData[])
                            .subscribe(
                                data => {
                                    this.energyActualData = data;
                                    this.dataLoadedEvent.emit("energyconsumption");
                                },
                                error => console.error(error));

                        this.http.get(this.baseUrl + 'api/data/solar', { headers: headers })
                            .map(res => res.json() as ProfileData[])
                            .subscribe(
                                data => {
                                    this.solarActualData = data;
                                    this.dataLoadedEvent.emit("energyproduction");
                                },
                                error => console.error(error));

                        this.http.get(this.baseUrl + 'api/data/gas', { headers: headers })
                            .map(res => res.json() as ProfileData[])
                            .subscribe(
                                data => {
                                    this.gasActualData = data;
                                    this.dataLoadedEvent.emit("gasconsumption");
                                },
                                error => console.error(error));

                        // Island
                        this.http.get(this.baseUrl + 'api/data/energyconsumption?aggregateToIsland=true', { headers: headers })
                            .map(res => res.json() as ProfileData[])
                            .subscribe(
                                data => {
                                    this.islandEnergyActual = data;
                                    this.dataLoadedEvent.emit("islandconsumption");
                                },
                                error => console.error(error));

                        this.http.get(this.baseUrl + 'api/data/solar?aggregateToIsland=true', { headers: headers })
                            .map(res => res.json() as ProfileData[])
                            .subscribe(
                                data => {
                                    this.islandSolarActual = data;
                                    this.dataLoadedEvent.emit("islandproduction");
                                },
                                error => console.error(error));

                },
                // Error verifying participant
                error => console.error(error));
            

            this.http.get(this.baseUrl + 'api/profile/energy', { headers: headers })
                .map(res => res.json() as ProfileData[])
                .subscribe(
                    data => {
                        this.energyProfileData = data;
                        this.dataLoadedEvent.emit("energy");
                    },
                    error => console.error(error));

            this.http.get(this.baseUrl + 'api/profile/solar', { headers: headers })
                .map(res => res.json() as ProfileData[])
                .subscribe(
                    data => {
                        this.solarProfileData = data;
                        this.dataLoadedEvent.emit("solar");
                    },
                    error => console.error(error));

            this.http.get(this.baseUrl + 'api/profile/gas', { headers: headers })
                .map(res => res.json() as ProfileData[])
                .subscribe(
                    data => {
                        this.gasProfileData = data;
                        this.dataLoadedEvent.emit("gas");
                    },
                    error => console.error(error));


            // Island data
            this.http.get(this.baseUrl + 'api/profile/energyisland', { headers: headers })
                .map(res => res.json() as ProfileData[])
                .subscribe(
                    data => {
                        this.islandEnergyProfile = data;
                        this.dataLoadedEvent.emit("islandconsumptionprofile");
                    },
                    error => console.error(error));

            this.http.get(this.baseUrl + 'api/profile/solarisland', { headers: headers })
                .map(res => res.json() as ProfileData[])
                .subscribe(
                    data => {
                        this.islandSolarProfile = data;
                        this.dataLoadedEvent.emit("islandproductionprofile");
                    },
                    error => console.error(error));


            // pricing
            this.http.get(this.baseUrl + 'api/profile/apx', { headers: headers })
                .map(res => res.json() as ApxData)
                .subscribe(
                    data => {
                        this.apxProfile = data;
                        this.dataLoadedEvent.emit("apxprofile");
                    },
                    error => console.error(error));

            this.http.get(this.baseUrl + 'api/data/apx' , { headers: headers })
                .map(res => res.json() as ProfileData[])
                .subscribe(
                data => {
                    this.apxActualData = data;
                        this.dataLoadedEvent.emit("energy");
                    },
                    error => console.error(error));
        });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/_shared/services/energy-data.service.ts